import useRouterHomeRedirect from "@/composables/useRouterHomeRedirect";
import useRouterLoginRedirect from "@/composables/useRouterLoginRedirect";
import useRouterOAuthHashHoist from "@/composables/useRouterOAuthHashHoist";
import useRouterOAuthSession from "@/composables/useRouterOAuthSession";
import useRouterOnboardingRedirect from "@/composables/useRouterOnboardingRedirect";
import useRouterSessionFetch from "@/composables/useRouterSessionFetch";
import { routes } from "@/lib/router/routes";
import { createRouter as createVueRouter, createWebHistory } from "vue-router";

export function createRouter () {
  const router = createVueRouter({
    history: createWebHistory(),
    routes,
  });

  useRouterOAuthHashHoist(router);
  useRouterSessionFetch(router);
  useRouterOAuthSession(router);
  useRouterLoginRedirect(router);
  useRouterHomeRedirect(router);
  useRouterOnboardingRedirect(router);

  return router;
}
